module.exports = __webpack_public_path__ + "img/beneficio5.9ce55966.svg";